// The check-scene gallery (spec 027, dev and staging): the guard only; the page is in
// gallery_.checks.lazy.tsx, outside the initial chunk. Not nested in /gallery, which has no outlet.
import { createFileRoute, notFound } from '@tanstack/react-router'

import { galleryEnabled } from '../lib/env.js'

export const Route = createFileRoute('/gallery_/checks')({
  beforeLoad: () => {
    if (!galleryEnabled()) {
      throw notFound()
    }
  },
})
